'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiInfoLarge = function TiInfoLarge(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.1 29.2c0 0-1 0.3-1.8 0.3-0.4 0-0.6-0.1-0.6-0.1-0.3-0.2-0.8-0.6 0-2.3l1.7-3.4c1-1.9 1.1-3.9 0.4-5.3-0.6-1.3-1.7-2.1-3.2-2.4-0.5-0.1-1-0.2-1.6-0.2-3.1 0-5.1 1.8-5.2 1.9-0.3 0.3-0.4 0.7-0.2 1.1 0.2 0.3 0.6 0.5 1 0.3 0 0 0.9-0.3 1.7-0.3 0.5 0 0.7 0.1 0.7 0.1 0.3 0.2 0.8 0.6-0.1 2.4l-1.6 3.3c-1 2-1.2 3.9-0.5 5.4 0.6 1.2 1.8 2 3.2 2.3 0.6 0.1 1.1 0.2 1.6 0.2 3.1 0 5.2-1.8 5.3-1.9 0.3-0.2 0.4-0.7 0.2-1-0.2-0.4-0.7-0.5-1-0.4z m2.7-19.2c0 2.3-1.8 4.2-4.1 4.2s-4.2-1.9-4.2-4.2c0-2.3 1.9-4.2 4.2-4.2s4.1 1.9 4.1 4.2z' })
        )
    );
};

exports.default = TiInfoLarge;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/info-large.js
// module id = 3629
// module chunks = 0